import emma from '@/common/services/Emma'

const PaymentMethodResource = {
	getPaymentMethods () { return emma.get('api/billing/payment-method/') },
	newPaymentMethod (data) { return emma.post('api/billing/payment-method/', data) },
	editPaymentMethod (id, data) { return emma.post('api/billing/payment-method/' + id, data) },
	deletePaymentMethod (id) { return emma.post('api/billing/payment-method/' + id + '/delete', []) }
}

export default PaymentMethodResource



// WEBPACK FOOTER //
// ./src/common/resources/PaymentMethod.js